import helper from 'helpers/steinerHelper';

export const actionTypes = helper.createActionTypes('offerte');
export const actions = helper.createActions('offerte', actionTypes);
